import React from 'react';
import ProductContainer from './Container';
import type { ProductCardProps } from './types';
import classNames from 'classnames';
import CardHead from './meta/card-head/card-head-vertical';
import CardBody from './meta/card-body/card-body-vertical';
import ProductAddCart from './meta/add-cart';
import WeeeVideo, { WeeeVideoRefProps } from '@/components/pdp/Picture/video';
import { ViewportLoad } from '@/components/common/LazyLoad';
import { useMemo, useRef } from 'react';
import { getCroppedImageUrl } from '../CroppedImage';
import { ProductMediaItem } from '@/types/product';
import CardHeadLabel from './meta/card-head/card-head-label';
import EnchancedFavorite from './meta/enchanced-favorite';

/**
 * 获取视频数据
 * 最新改动：接口新返回media字段，包含媒体类型、图片/视频地址等信息
 * 这里兼容下新旧数据
 * @param data 商品数据
 */
const getVideoInfo = (data: ProductType): ProductMediaItem | null => {
  if ('media' in data) {
    return data.media.media_type === 'video' ? data.media : null;
  }
  return data?.media_urls?.find(item => item?.media_type === 'video');
};

const VerticalVideo: React.FC<Partial<ProductCardProps>> = props => {
  const { data, onViewChange, viewOptions, imageSize, className, ...rest } = props;
  const weeeVideoRef = useRef<WeeeVideoRefProps>(null);
  const cardEl = useRef<HTMLDivElement>(null);

  const videoDetail = useMemo(() => {
    return getVideoInfo(data);
  }, [data]);

  return (
    <ProductContainer
      interactiveSlot={
        <div
          className="absolute right-0 top-0 w-full pointer-events-none"
          style={{
            paddingTop: '100%'
          }}>
          <EnchancedFavorite {...props} />
          <ProductAddCart data={data} {...rest} />
        </div>
      }
      {...props}>
      <div className={classNames('p-0')} ref={cardEl}>
        <CardHead
          data={data}
          {...rest}
          showFavorite={false}
          imageNode={() => {
            if (videoDetail && !!onViewChange) {
              return (
                <ViewportLoad
                  placeholder={<div className="w-full h-full absolute top-0 left-0 rounded object-cover m-0" />}
                  initialLoad
                  viewOptions={{
                    delay: 200,
                    threshold: 1,
                    ...viewOptions
                  }}
                  onViewChange={inView => {
                    props?.onViewChange?.({
                      inView,
                      play: () => {
                        weeeVideoRef.current?.autoPlayVideo();
                      },
                      stop: () => {
                        weeeVideoRef.current?.resetVideo();
                      },
                      productInfo: data,
                      mediaItem: videoDetail,
                      cardElement: cardEl.current!
                    });
                  }}>
                  <div>
                    <WeeeVideo
                      ref={weeeVideoRef}
                      poster={getCroppedImageUrl(videoDetail?.url, {
                        renderWidth: imageSize || 170,
                        devicePixelRatio: 2
                      })}
                      src={videoDetail.media_url}
                      loop={videoDetail.autoplay === -1}
                      videoClassName="w-full h-full absolute rounded object-cover"
                      playClassName="w-5 h-5 left-2 bottom-2 z-10 absolute"
                      className="w-full h-full absolute top-0 left-0 rounded object-cover"
                      controlPanel={{ showMuteIcon: false, showPlayIcon: true }}
                      defaultProps={{ showPlayIcon: true }}
                    />
                  </div>
                </ViewportLoad>
              );
            }
            return null;
          }}>
          {/* <ProductAddCart data={data} {...rest} /> */}
        </CardHead>
        <CardBody data={data} {...rest} />
      </div>
    </ProductContainer>
  );
};

export default VerticalVideo;
